(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ga4-tracker-section"] && !Shopify.designMode) return;
  try {
    
  // 可选：如果将来要读 settings.enable，可以在这里做开关逻辑

  } catch(e) { console.error(e); }
})();
})();
